export default class ImageService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('images', params)
	}

	createEntity(params){
		return this.apiService.callPost('images', params);
	}

	updateEntity(id, params){
		return this.apiService.callPost('images/' + id, params);
	}

	getConstraints(params) {
		return this.apiService.callGet('images_constraints', params)
	}

	getEntity(id, params) {
		return this.apiService.callGet('images/' + id, params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('images/' + id, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/ImageService.js